import { RequestInterceptor, IInterceptorConfig } from '../interceptor'
import { getAuthToken } from '../utils';

export default class AuthToken extends RequestInterceptor {
  static INTERCEPTOR_KEY = 'authToken'

  async resolve(config: IInterceptorConfig) {
    if (this.shouldSkipInterceptor(this, config)) {
      return config
    }

    // Check if running locally - skip authentication for local development
    const isLocalhost = typeof window !== 'undefined' && (
      window.location.hostname === 'localhost' || 
      window.location.hostname === '127.0.0.1' ||
      window.location.hostname.includes('192.168.') ||
      window.location.hostname.includes('10.0.') ||
      window.location.hostname.includes('172.')
    )

    // Check if this is a public endpoint - skip authentication
    const isPublicEndpoint = config.url && config.url.includes('/api/public/')

    // Only add Authorization header if not running locally and not a public endpoint
    if (!isLocalhost && !isPublicEndpoint) {
      config.headers = config.headers || {}
      config.headers.Authorization = getAuthToken()
    }

    return config
  }
}
